/* ============================================================
   SKRATCH LABS ZA — product.js
   Variant selection, gallery, add to cart
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── ONLY RUN ON PRODUCT PAGES ─────────────────────────────
  const variantDataEl = document.getElementById('sl-product-variants');
  if (!variantDataEl) return;

  const variants = JSON.parse(variantDataEl.textContent);
  const form = document.querySelector('[data-type="add-to-cart-form"]');
  if (!form) return;

  const variantInput = document.getElementById('sl-variant-id');
  const priceEl = document.getElementById('sl-pdp-price');
  const atcBtn = document.getElementById('sl-atc-btn');
  const atcPrice = document.getElementById('sl-atc-price');
  const atcLabel = document.getElementById('sl-atc-label');

  // ── VARIANT MATCHING ──────────────────────────────────────
  function getSelectedOptions() {
    const options = {};
    form.querySelectorAll('.sl-pdp-option__radio:checked').forEach(function (radio) {
      const idx = parseInt(radio.dataset.optionIndex, 10);
      options[idx] = radio.value;
    });
    return options;
  }

  function findVariant(selectedOptions) {
    return variants.find(function (v) {
      return Object.keys(selectedOptions).every(function (idx) {
        return v['option' + (parseInt(idx, 10) + 1)] === selectedOptions[idx];
      });
    });
  }

  function formatMoney(cents) {
    return 'R' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateVariant() {
    const selectedOptions = getSelectedOptions();
    const variant = findVariant(selectedOptions);

    // Update selected labels
    Object.keys(selectedOptions).forEach(function (idx) {
      const labelEl = document.getElementById('sl-option-selected-' + idx);
      if (labelEl) labelEl.textContent = selectedOptions[idx];
    });

    // Update option pill/swatch active states
    form.querySelectorAll('.sl-pdp-option').forEach(function (optionEl) {
      const idx = optionEl.dataset.optionIndex;
      optionEl.querySelectorAll('.sl-pdp-option__pill, .sl-pdp-option__swatch').forEach(function (label) {
        const radio = label.querySelector('.sl-pdp-option__radio');
        if (radio) {
          label.classList.toggle('is-active', radio.checked);
        }
      });
    });

    if (!variant) return;

    // Update variant input
    if (variantInput) variantInput.value = variant.id;

    // Update price
    if (priceEl) {
      let priceHTML = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHTML += '<span class="sl-pdp-price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
      }
      priceHTML += '<span class="sl-pdp-price__current">' + formatMoney(variant.price) + '</span>';
      priceEl.innerHTML = priceHTML;
    }

    // Update ATC button
    if (atcBtn) {
      if (variant.available) {
        atcBtn.disabled = false;
        if (atcLabel) atcLabel.textContent = 'add to cart';
        if (atcPrice) atcPrice.textContent = formatMoney(variant.price);
      } else {
        atcBtn.disabled = true;
        if (atcLabel) atcLabel.textContent = 'sold out';
      }
    }

    // Update gallery if variant has image
    if (variant.featured_image) {
      const mainImg = document.getElementById('sl-gallery-main-img');
      if (mainImg) {
        mainImg.src = variant.featured_image.src + '?width=900';
        mainImg.alt = variant.featured_image.alt || '';
      }
    }

    // Update URL
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  // Listen to all option radios
  form.querySelectorAll('.sl-pdp-option__radio').forEach(function (radio) {
    radio.addEventListener('change', updateVariant);
  });

  // ── GALLERY THUMBNAILS ────────────────────────────────────
  const mainImg = document.getElementById('sl-gallery-main-img');
  document.querySelectorAll('.sl-pdp-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || '';
          mainImg.style.opacity = '1';
        }, 150);
      }
      document.querySelectorAll('.sl-pdp-gallery__thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    });
  });

  // ── QUANTITY SELECTOR ─────────────────────────────────────
  const qtyInput = document.getElementById('sl-qty-input');
  document.querySelector('.sl-pdp-qty__btn--minus')?.addEventListener('click', function () {
    if (qtyInput && parseInt(qtyInput.value, 10) > 1) {
      qtyInput.value = parseInt(qtyInput.value, 10) - 1;
    }
  });
  document.querySelector('.sl-pdp-qty__btn--plus')?.addEventListener('click', function () {
    if (qtyInput) qtyInput.value = parseInt(qtyInput.value, 10) + 1;
  });

  // ── ADD TO CART ───────────────────────────────────────────
  if (atcBtn && form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = variantInput ? variantInput.value : '';
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!variantId) return;

      atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = 'adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (atcLabel) atcLabel.textContent = 'added!';
          // Update cart count in header
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              const countEl = document.querySelector('.sl-cart-count');
              if (countEl) countEl.textContent = cart.item_count;
            });
          setTimeout(function () {
            atcBtn.disabled = false;
            if (atcLabel) atcLabel.textContent = 'add to cart';
            if (atcPrice && variantInput) {
              const v = variants.find(function (x) { return x.id == variantInput.value; });
              if (v) atcPrice.textContent = formatMoney(v.price);
            }
          }, 2000);
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          atcBtn.disabled = false;
          if (atcLabel) atcLabel.textContent = 'error — try again';
          setTimeout(function () {
            if (atcLabel) atcLabel.textContent = 'add to cart';
          }, 3000);
        });
    });
  }

});
